import TreeSelect from './components/TreeSelect';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'treeSelect',
  pluginComponent: TreeSelect,
});
